<!--公用组件：confirm弹框
    @dengli
    @date 2018.10.30
    props
        - confirmButtonText {String}  - 确认按钮文字
        - showCancelButton {boolean}  - 是否启动取消按钮
        - content {String}  - 弹出框显示的内容
        - handleConfirm {function}  点击确认后进行的处理
    调用实例：
        - <lanhu-dialog
            :showCancelButton="showCancelButton"
            :content="dialogText"
            :handleConfirm="goUpdate"
            :confirmButtonText="confirmButtonText"
        />
-->
<template>
    <div>
        <div class="lanhu-msgbox-wrapper">
            <transition enter-active-class="animated faster zoomIn" leave-active-class="animated faster zoomOut">
                <div class="lanhu-msgbox" v-show="open">
                    <div class="lanhu-msg-content border-bottom">{{content}}</div>
                    <div class="lanhu-mgs-button-wrapper">
                        <div class="confirm" :class="{'border-right': showCancelButton }" @click="handleConfirm">{{confirmButtonText}}</div>
                        <div class="cancel" v-show="showCancelButton" @click="close">{{cancelButtonText}}</div>
                    </div>
                </div>
            </transition>
        </div>
        <transition enter-active-class="animated faster fadeIn" leave-active-class="animated faster fadeOut">
            <div class="v-modal" v-show="open"></div>
        </transition>
    </div>
</template>
<style lang="scss" scoped>
.lanhu-msgbox-wrapper{
    position: absolute;
    z-index: 2019;
    .lanhu-msgbox{
        position: fixed;
        top: 50%;
        left: 50%;
        margin: -2.425rem -6.15rem;
        width:12.3rem;
        height:4.95rem;
        background:white;
        border-radius:0.65rem;
        overflow: hidden;
        .lanhu-msg-content{
            height: 2.88rem;
            text-align: center;
            width: 100%;
            line-height: 2.88rem; 
            font-size:0.8rem;
            font-weight:500;
            color:rgb(34,34,34);
        }
        .lanhu-mgs-button-wrapper{
            width: 100%;
            text-align: center;
            height: 2rem;
            .confirm,.cancel{
                display: inline-block;
                vertical-align: center;
                width: 50%;
                height: 2.05rem;
                font-size:0.8rem;
                font-weight:500;
                color:rgba(40,120,255,1);
                line-height: 2.05rem;
            }
            .confirm:active,.cancel:active {
                background-color: #EEEEEE;
            }
        }
    }
}
.v-modal{
    z-index: 2018;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    opacity: .5;
    background: #000;
}
</style>

<script>
export default {
    name: 'LanhuDialog',
    data() {
        return {
            open: false,
        }
    },
    props: {
        cancelButtonText: {
            type: String,
            default: '取消'
        },
        confirmButtonText: {
            type: String,
            default: ''
        },
        showCancelButton: {
            type: Boolean,
            default: false
        },
        content: {
            type: String,
            default: ''
        },
        handleConfirm: null
    },
    methods: {
        openDialog() {
            localStorage.setItem('bann','true')
            this.open = true
        },
        close() {
            localStorage.setItem('bann','')
            this.open = false
        }
    }
}
</script>



